import axios from "axios";

const baseDomain = process.env.REACT_APP_BackendURL;
const baseURL = `${baseDomain}`;

const axiosObj = axios.create({
  baseURL
});

export default {
  checkUser(tableName, table_no, buid, subscription, phoneNumber) {
    return axiosObj
      .post(`/table-sessions/check`, {
        table_name: tableName,
        businessLocationId: buid,
        table_id: table_no,
        subscription: subscription,
        phoneNumber
      })
      .then((res) => {
        return res.data;
      });
  },
  createTable(tableName, table_no, buid, subscription, phoneNumber, notificationStatus, tableType) {
    return axiosObj
      .post(`/table-sessions/create`, {
        table_name: tableName,
        businessLocationId: buid,
        table_id: table_no,
        space_used: 1,
        subscription: subscription,
        phoneNumber,
        notificationStatus,
        table_type: tableType
      })
      .then((res) => {
        return res.data;
      });
  },
  checkOrCreateTable(
    tableName,
    table_no,
    buid,
    subscription,
    phoneNumber,
    notificationStatus,
    tableType
  ) {
    return axiosObj
      .post(`/table-sessions/check_or_create`, {
        table_name: tableName,
        businessLocationId: buid,
        table_id: table_no,
        space_used: 1,
        subscription: subscription,
        phoneNumber,
        notificationStatus,
        table_type: tableType
      })
      .then((res) => {
        return res.data;
      });
  }
};
